import axios from "axios/index";
import authHeader from "../../authHeader";

const state = {
  partners: {
    isLoading: false,
    isError: false,
    data: [],
  },
};

const getters = {
  isError: (state) => {
    return state.partners.isError;
  },
  isLoading: (state) => {
    return state.partners.isLoading;
  },
  partnersData: (state) => {
    return state.partners.data;
  },
};

const mutations = {};

const actions = {
  setPartners: (context) => {
    context.state.partners.isLoading = true;
    let headers = authHeader();
    axios({
      method: "GET",
      url: "/partner",
      headers: headers,
    })
      .then((res) => {
        context.state.partners.data = res.data;
        context.state.partners.isLoading = false;
      })
      .catch((error) => {
        context.state.partners.isLoading = false;
        context.state.partners.isError = true;

        console.log("Error while reading data (E8273): " + error);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/partner.js